import {AttendanceDisplayMode} from './attendanceWizardTypes'

function findColumn(columns: string[], candidates: string[]): string | null {
  const lower = columns.map((c) => c.toLowerCase())
  for (const candidate of candidates) {
    const idx = lower.indexOf(candidate.toLowerCase())
    if (idx >= 0) return columns[idx]
  }
  return null
}

/** Table columns for student PDF/Excel — identity lives in header/meta only. */
export function pickStudentRecordExportColumns(
  columns: string[],
  attendanceMode?: AttendanceDisplayMode
): string[] {
  if (columns.includes('Metric') && columns.includes('Value')) {
    return ['Metric', 'Value']
  }

  const dateCol = findColumn(columns, ['date', 'day', 'attendance date'])
  const statusCol = findColumn(columns, ['status', 'attendance', 'remark'])
  const subjectCol = findColumn(columns, ['subject'])

  if (attendanceMode === 'subject' && subjectCol) {
    return [dateCol, subjectCol, statusCol].filter((c): c is string => Boolean(c))
  }

  return [dateCol, statusCol].filter((c): c is string => Boolean(c))
}

export function mapRowsToExportColumns(
  rows: Record<string, string>[],
  exportColumns: string[]
): Record<string, string>[] {
  return rows.map((row) => {
    const out: Record<string, string> = {}
    for (const col of exportColumns) {
      out[col] = row[col] ?? ''
    }
    return out
  })
}
